<template lang="pug">
    v-layout( row wrap )
            v-flex( :key='index' xs12 sm6 md4 lg3 v-for='( item, index ) in items' )
                v-card.elevation-1
                    v-card-text
                        h1.title.mt-5.mx-2 {{ item.title }}
                    v-card-actions.d-inline-block( style='width: 100%;' )
                        v-list( dense )
                            v-list-tile( :key='subindex' ripple :color='subitem.color' v-for='( subitem, subindex ) in item.items' @click='$router.push( subitem.route )' )
                                v-list-tile-title( :class='subitem.class + ( subindex < 1 ? " body-2" : " body-1" ) ' ) {{ subitem.title }}
</template>

<script>
    export default {
        props: {

            /**
             * 
             */
            items: Array,
        }
    }
</script>

